import z from "zod"
import { ClusterSnapshotDataSchema } from "../../insights/response_data"

export const BackofficeGetCompanyClusterSnapshotsResponseDataSchema =
  z.array(ClusterSnapshotDataSchema)
